import { HttpClient } from './httpClient';
import { API_URL } from './RestAPI';
import apiHeaders from './apiHeaders';

const NOTIFICATION_SETTINGS_API = `${API_URL}/notification-settings`;

const getNotificationSettings = () => {
  return HttpClient.get(
    `${NOTIFICATION_SETTINGS_API}`,
    apiHeaders()
  );
};

const updateNotificationSettings = (payload) => {
  return HttpClient.put(
    `${NOTIFICATION_SETTINGS_API}`,
    payload,
    apiHeaders()
  );
};

const NotificationSettingsApi = { getNotificationSettings, updateNotificationSettings };

export { NotificationSettingsApi };